import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';

export default class OrganizationsScreen extends React.Component {
    constructor(props) {
        super(props);

        const args = props.args === undefined ? {} : props.args

        this.state = {
              args: args, 
              organizations: []  
        }
    }  
    
    async componentDidMount() {
        BaseApi.get('/project/organizations', {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            this.setState({organizations: res.data})
        })    
        .catch(error=>console.log(error))
    }

    openOrganization(id) {
        this.props.navigate("organization", {caller: "organizations", callargs: this.state.args, organization: id})
    }

    renderOrganization(organization) {
        return (
            <tr
                id = {organization.id}
                className="table-row-clickable"
                onClick={()=>this.openOrganization(organization.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {organization.shortname}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {organization.name}
                </td>
            </tr>
        )      
    }

    render() {
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Программы"}/>
                 <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        
                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openOrganization("")}
                        >
                            Добавить организацию
                        </button>
                    </div>
                 </div>
                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th id="shortnameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Краткое наименование
                                        </th>
                                        <th id="nameCaption" style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                            Полное наименование
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.organizations.map((value, index) => this.renderOrganization(value))}
                                </tbody>
                            </table>      
                        </div>
                    </div>
                </div>        
            </div> 
        )
    }
}    


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/organizations.js